'use client';
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';

const demoChanges = [
  { from: '18:40', to: '20:10', label: 'Flight departure', type: 'critical' },
  { from: '£10.99', to: '£12.99', label: 'Netflix · +£24/year', type: 'warning' },
  { from: 'Today', to: 'Tomorrow', label: 'Delivery rescheduled', type: 'info' },
];

export default function AuthBrand() {
  return (
    <div className="flex flex-col justify-between p-12 xl:p-16 w-full relative z-10">
      {/* Logo */}
      <div className="flex items-center gap-3">
        <img
          src="/assets/images/9233ac2a-da42-49dd-8741-1bbcb2a05a7e-1786734258348.png"
          alt="ChangedSince logo"
          className="w-9 h-9 object-contain"
        />
        <span className="font-bold text-lg tracking-tight">
          <span className="text-white">Changed</span><span style={{ color: '#22c55e' }}>Since</span>
        </span>
      </div>
      {/* Hero */}
      <div>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-hero-lg font-bold text-white mb-6"
        >
          Know what changed.
          <br />
          <span className="text-teal-light">Know what matters.</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="text-base text-white/60 leading-relaxed max-w-sm mb-10"
        >
          ChangedSince watches the services you choose, detects meaningful changes,
          and tells you when something deserves your attention.
        </motion.p>

        {/* Demo cards */}
        <div className="space-y-3">
          {demoChanges?.map((change, index) => (
            <motion.div
              key={`demo-change-${index}`}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 0.3 + index * 0.12 }}
              className="flex items-center gap-3 p-3.5 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm"
            >
              <div className={`w-2 h-2 rounded-full flex-shrink-0 ${
                change?.type === 'critical' ? 'bg-critical' :
                change?.type === 'warning' ? 'bg-warning' : 'bg-accent'
              }`} />
              <div className="flex items-center gap-2 flex-1">
                <span className="text-sm font-bold text-white/50 line-through tabular-nums">{change?.from}</span>
                <ArrowRight size={12} className="text-primary flex-shrink-0" />
                <span className="text-sm font-bold text-white tabular-nums">{change?.to}</span>
              </div>
              <span className="text-xs text-white/40">{change?.label}</span>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.8 }}
          className="mt-8 flex items-center gap-2 text-sm text-white/40"
        >
          <CheckCircle size={14} className="text-positive" />
          Everything else looks normal.
        </motion.div>
      </div>
      {/* Footer */}
      <p className="text-xs text-white/25">
        Your world. Your permissions. Your control.
      </p>
    </div>
  );
}